export const EventTypes = {
  AdjustPlans: "AdjustPlans",
  PrintPublicReport: "PrintPublicReport",
  ReRenderPortals: "ReRenderPortals",
  SaveReport: "SaveReport",
  ScrollToTop: "ScrollToTop",
} as const;
export type EventTypes = typeof EventTypes[keyof typeof EventTypes];
